import type { RouteRecord } from 'vite-react-ssg';
import { lazy } from 'react';
import App from './App';

const Landing = lazy(() => import('./pages/Landing'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const NotFound = lazy(() => import('./pages/NotFound'));

const AdminLogin = lazy(() => import('./pages/admin/Login'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'));
const AdminContacts = lazy(() => import('./pages/admin/Contacts'));
const AdminContactDetail = lazy(() => import('./pages/admin/ContactDetail'));
const AdminSeo = lazy(() => import('./pages/admin/Seo'));

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Landing />, entry: 'src/pages/Landing.tsx' },
      { path: 'about', element: <About />, entry: 'src/pages/About.tsx' },
      { path: 'contact', element: <Contact />, entry: 'src/pages/Contact.tsx' },
      { path: 'privacy', element: <Privacy />, entry: 'src/pages/Privacy.tsx' },
      { path: 'terms', element: <Terms />, entry: 'src/pages/Terms.tsx' },
      // Admin routes are SPA-only — excluded from prerender via
      // `ssgOptions.includedRoutes` in vite.config.ts.
      { path: 'admin/login', element: <AdminLogin /> },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminDashboard /> },
          { path: 'contacts', element: <AdminContacts /> },
          { path: 'contacts/:id', element: <AdminContactDetail /> },
          { path: 'seo', element: <AdminSeo /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
];
